import { useSession } from "../session/useSession";
import { Step1Discovery } from "../steps/Step1Discovery";
import { Step2Specs } from "../steps/Step2Specs";
import { Step3Options } from "../steps/Step3Options";
import { Step4Compare } from "../steps/Step4Compare";
import { Step5Buy } from "../steps/Step5Buy";

/**
 * Renderiza el componente de Step correspondiente al paso actual.
 *
 * También muestra el aviso "se restauró tu búsqueda anterior" si aplica.
 *
 * Patrón: switch sobre session.step. Cada Step se desmonta al cambiar,
 * lo que cancela requests pendientes (gracias al cleanup del AbortController
 * que vimos en useResearchSession).
 */
export function StepContainer() {
  const { step, restoredNotice, startNewSession, dismissRestoredNotice } =
    useSession();

  return (
    <>
      {restoredNotice && (
        <div style={styles.restoredBanner}>
          <span>📂 Se restauró tu búsqueda anterior.</span>
          <div style={{ display: "flex", gap: "8px" }}>
            <button style={styles.bannerBtn} onClick={dismissRestoredNotice}>
              Entendido
            </button>
            <button style={styles.bannerBtnDanger} onClick={startNewSession}>
              Empezar de nuevo
            </button>
          </div>
        </div>
      )}

      {step === 1 && <Step1Discovery />}
      {step === 2 && <Step2Specs />}
      {step === 3 && <Step3Options />}
      {step === 4 && <Step4Compare />}
      {step === 5 && <Step5Buy />}
    </>
  );
}

const styles = {
  restoredBanner: {
    background: "#eef6ff",
    border: "1px solid #bcdcff",
    padding: "12px 18px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    maxWidth: "780px",
    margin: "20px auto",
    borderRadius: "8px",
    fontFamily: "sans-serif",
    fontSize: "13px",
    color: "#1a4a7a",
  },
  bannerBtn: {
    background: "transparent",
    color: "#1a4a7a",
    border: "1px solid #1a4a7a",
    borderRadius: "6px",
    padding: "6px 12px",
    fontSize: "12px",
    cursor: "pointer",
    fontFamily: "sans-serif",
  },
  bannerBtnDanger: {
    background: "#1a4a7a",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    padding: "6px 12px",
    fontSize: "12px",
    cursor: "pointer",
    fontFamily: "sans-serif",
  },
};
